import { Model } from '@vuex-orm/core';

export default class FlashcardBuilderState extends Model {
    static entity = 'flashcard_builder_state';

    static primaryKey = 'uuid';

    static fields() {
        return {
            uuid: this.attr(null),
            currentStep: this.attr(1),
            // Step 1: Content
            selectedItems: this.attr(() => []),
            externalText: this.attr(''),
            attachedFiles: this.attr(() => []),
            // Step 2: Settings
            title: this.attr(''),
            numberOfCards: this.attr(10),
            difficulty: this.attr('intermediate'),
            bloomsLevel: this.attr(null),
            includeImages: this.attr(false),
            imageStyle: this.attr('educational_diagram'),
            sessionSize: this.attr(null),
            // Step 3: Preview
            sections: this.attr(() => []),
            contentMaterials: this.attr(() => []),
            isGenerating: this.attr(false),
            statusMessage: this.attr(''),
            isLoadingImages: this.attr(false),
            imageLoadingProgress: this.attr(''),
        };
    }
}
